module.exports = __webpack_public_path__ + "img/slide-services-3.2af32564.webp";